import React from "react";
import { Outlet } from "react-router-dom";
import PublicHeader from "../../components/PublicHeader";
import PublicFooter from "../../components/PublicFooter";
import SharedWhatsAppAiButton from "../../../app/components/SharedWhatsAppAiButton";

const PublicLayout = () => {
    return (
        <div className="public-layout">
            <PublicHeader />

            <main className="public-content">
                <Outlet />
            </main>

            <PublicFooter />
            <SharedWhatsAppAiButton />
        </div>
    );
};

export default PublicLayout;
